module.exports = __webpack_public_path__ + "img/vs-2.9cd501c8.png";